import { ignoreElements, mergeMap, groupBy } from 'rxjs/operators';

export function groupByFunction(key, keyValue, subject) {
  return subject.pipe(
    groupBy((value) => value[key]),
    mergeMap((groupedObservable) => {
      if (groupedObservable.key === keyValue) return groupedObservable;
      else return groupedObservable.pipe(ignoreElements());
    })
  );
}
/* 
  positions: {
    BACKTEST: {
      id3: {...values},
        id4: {...values},
        id6: {...values},
    }
    6Y43D2: {
      tradier: {
        id3: {...values},
        id4: {...values},
        id6: {...values},
      }
      tradeUnafraid:{
        id3: {...values},
        id4: {...values},
        id6: {...values},
      }
    }
  }
*/
